export default __webpack_public_path__ + "media/Confluence_left.d29a4cdeb5a00e51d15af000f089ecf8.svg";